import { useState } from "react";
import { Task } from "model/task";
import { Notification } from "model/notification";
import { NotificationTaskType } from "services/tasks";
import { deleteNotifications } from "services/notifications";
import { TaskListItem } from "./components/TaskListItem";
import { NotificationListItem } from "./components/NotificationListItem";
import "./NotificationsList.css";

interface NotificationListProps {
  tasks: Task[];
  notifications: Notification[];
  closeDetails: () => void;
  refresh: () => void;
}

export default function NotificationsList({
  tasks,
  notifications,
  closeDetails,
  refresh,
}: NotificationListProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteAllNotifications = () => {
    setIsDeleting(true);
    deleteNotifications(
      { notifications: notifications.map(({ id }) => id) },
      () => {
        refresh();
      },
      () => {
        refresh();
      }
    );
  };
  const items =
    tasks.length === 0 && notifications.length === 0 ? (
      <div className="notification-list-item">There are no new notifications.</div>
    ) : (
      [
        ...tasks.map((item, index) => {
          if (
            item.type === NotificationTaskType.FEEDBACK ||
            item.type === NotificationTaskType.PLAN
          ) {
            return <TaskListItem key={index} item={item} closeDetails={closeDetails} />;
          } else {
            return null;
          }
        }),
        ...notifications.map(notification => (
          <NotificationListItem
            key={notification.id}
            item={notification}
            closeDetails={closeDetails}
            refresh={refresh}
          />
        )),
      ]
    );

  return (
    <>
      {notifications.length > 1 && (
        <div className="notifications-clear-all">
          <button onClick={deleteAllNotifications} disabled={isDeleting}>
            Clear All
          </button>
        </div>
      )}
      <div className="notifications-list">{items}</div>
    </>
  );
}
